import { memo } from 'react';
import { LogDto } from '@/Domain/api/Conversation/dto/Log.dto';
import { sanitizeWithExternalLinks } from '@/Domain/helper/sanitize.helper';

type Props = {
  log: LogDto;
};

export const LogItem = memo(({ log }: Props) => (
  <li className="text-foreground-subtle text-sm text-center">
    <span dangerouslySetInnerHTML={{ __html: sanitizeWithExternalLinks(log.description) }}></span>
  </li>
));

LogItem.displayName = 'LogItem';
